<div class="astrea-book p-sm-4 p-2">
    <div class="container grid-25-75">
        <div class="p-2" *ngIf="!loading">
            <div class="mb-3">
                <img class="astrea-image img-responsive" [src]="S3Service.getImageURL(book.image)" alt="{{ book.title }}">
            </div>
            <div *ngIf="authors" class="mb-3">
                <div class="book-authors d-flex j-c-start a-i-start flex-column">
                    <a *ngFor="let a of authors" [routerLink]="['/author', a.authorcode]" title="{{ 'books.details.author' | translate }}: {{ a.firstname }} {{ a.lastname }}">
                        {{ a.lastname | uppercase }}, {{ a.firstname }} <small>({{ a.role }})</small>
                    </a>
                </div>
            </div>
        </div>
        <div *ngIf="!loading; else astreaLoading">
            <div *ngIf="book.vLegalMatter && book.vLegalMatter.length > 0" class="book-info">
                <p class="mb-2">
                    <a class="matter-badge" *ngFor="let lm of book.vLegalMatter" [routerLink]="['/materia', lm.url]" [title]="('books.details.matter' | translate) + ': ' + lm.legalMatter">
                        {{ lm.legalMatter }}
                    </a>
                </p>
            </div>
            <div class="astrea-title w-100 mb-3">
                <div class="d-flex j-c-between a-i-center">
                    <h1>{{ book.title }}</h1>
                    <mat-icon *ngIf="!wish; else addedWishlist" (click)="handleWishlist()" class="astrea-add-wishlist">
                        star_border
                    </mat-icon>
                    <ng-template #addedWishlist>
                        <mat-icon *ngIf="wish" class="astrea-add-wishlist">star</mat-icon>
                    </ng-template>
                </div>
                <h2 *ngIf="book.subtitle">{{ book.subtitle }}</h2>
            </div>
            <div class="book-info h-overflow">
                <p *ngIf="book.description" class="mb-2">
                    {{ book.description }}
                </p>
            </div>
            <div class="book-info w-100 my-3">
                <ul class="p-0">
                    <li>
                        <p><strong>{{ 'books.details.type' | translate }}:</strong> {{ getBookType(book.bookType) }}</p>
                    </li>
                    <li *ngIf="book.edition">
                        <p><strong>{{ 'books.details.edition' | translate }}:</strong> {{ book.edition }}{{ fnService.getOrdinalNumber(book.edition) }}</p>
                    </li>
                    <li *ngIf="book.vEditorial">
                        <strong>{{ 'books.details.editorial' | translate }}: </strong>
                        <a [routerLink]="['/editorial', book.vEditorial.url]" [title]="('books.details.editorial' | translate) + ': ' + book.vEditorial.editorial">{{ book.vEditorial.editorial }}</a>
                    </li>
                    <li *ngIf="book.year">
                        <p><strong>{{ 'books.details.year' | translate }}:</strong> {{ book.year }}</p>
                    </li>
                    <li *ngIf="book.pages">
                        <p><strong>{{ 'books.details.pages' | translate }}:</strong> {{ book.pages }}</p>
                    </li>
                    <li *ngIf="book.publishDate">
                        <p><strong>{{ 'books.details.publish' | translate }}:</strong> {{ book.publishDate }}</p>
                    </li>
                    <li *ngIf="book.isbn">
                        <p><strong>ISBN:</strong> {{ book.isbn }}</p>
                    </li>
                    <li *ngIf="getBookBinding(book.bookBinding)">
                        <p><strong>{{ 'books.details.cover' | translate }}:</strong> {{ getBookBinding(book.bookBinding) }}</p>
                    </li>
                    <li *ngIf="book.bookFormat">
                        <p><strong>{{ 'books.details.format' | translate }}:</strong> {{ book.bookFormat }}</p>
                    </li>
                    <li *ngIf="book.recopilation">
                        <strong>{{ 'books.details.collection' | translate }}: </strong>
                        <a [routerLink]="['/collection', book.recopilation.url]" [title]="('books.details.collection' | translate) + ': ' + book.recopilation.recopilation">{{ book.recopilation.recopilation }}</a>
                    </li>
                </ul>
            </div>
            <div class="my-3">
                <a *ngIf="book.hasAdenda" (click)="getFile('adenda', book.bookcode)" class="btn-book" [attr.alt]="'books.files.see_adenda' | translate" mat-button>
                    <div class="d-flex j-c-start a-i-center">
                        {{ 'books.files.adenda' | translate }}
                        <astrea-loading *ngIf="loadingFile.loading && loadingFile.type == 'adenda'" [diameter]="20" [stroke]="2"></astrea-loading>
                        <mat-icon *ngIf="!loadingFile.loading || loadingFile.type != 'adenda'">cloud_download</mat-icon>
                    </div>
                </a>
                <a *ngIf="book.hasIndex" (click)="getFile('index', book.bookcode)" class="btn-book" [attr.alt]="'books.files.see_index' | translate" mat-button>
                    <div class="d-flex j-c-start a-i-center">
                        {{ 'books.files.index' | translate }}
                        <astrea-loading *ngIf="loadingFile.loading && loadingFile.type == 'index'" [diameter]="20" [stroke]="2"></astrea-loading>
                        <mat-icon *ngIf="!loadingFile.loading || loadingFile.type != 'index'">cloud_download</mat-icon>
                    </div>
                </a>
                <a *ngIf="book.hasPrologue" (click)="getFile('prologue', book.bookcode)" class="btn-book" [attr.alt]="'books.files.see_prologue' | translate" mat-button>
                    <div class="d-flex j-c-start a-i-center">
                        {{ 'books.files.prologue' | translate }}
                        <astrea-loading *ngIf="loadingFile.loading && loadingFile.type == 'prologue'" [diameter]="20" [stroke]="2"></astrea-loading>
                        <mat-icon *ngIf="!loadingFile.loading || loadingFile.type != 'prologue'">cloud_download</mat-icon>
                    </div>
                </a>
            </div>

            <hr>

            <div *ngIf="!isPublicDoctrine && !isMagazine; else getPublicFile" class="book-price w-100 mb-3">
                <div class="d-flex j-c-start j-c-sm-around a-i-start flex-wrap">
                    <div class="p-1">
                        <h3>{{ 'books.cart.physical' | translate }}</h3>
                        <div *ngIf="book.available; else notAvailable" class="mb-3 mb-sm-1">
                            <p>{{ 'books.details.pricing' | translate }}: <strong>{{ pricingService.getCurrency() }}{{ pricingService.getWebPricing(book) | astreaCurrency }}</strong></p>
                            <button (click)="handlePhysicalBook()" class="btn btn-green mt-2" mat-button>
                                <mat-icon>shopping_cart</mat-icon>
                                {{ 'cart.add_physical' | translate }}
                            </button>
                        </div>
                        <ng-template #notAvailable>
                            <p><strong>{{ 'books.sold_out' | translate }}</strong></p>
                            <button *ngIf="!loadingWish" (click)="handleWishlist()" class="btn btn-green mt-2" mat-button>
                                <mat-icon class="mr-1">stars</mat-icon>
                                {{ 'wishlist.add' | translate }}
                            </button>
                            <button *ngIf="loadingWish" class="d-flex j-c-center a-i-center btn btn-green mt-2" mat-button>
                                <astrea-loading class="mr-2" [diameter]="20" [stroke]="2"></astrea-loading>
                                {{ 'wishlist.add' | translate }}
                            </button>
                        </ng-template>
                    </div>
                    <div *ngIf="book.useAV && !book.private" class="p-1">
                        <h3>{{ 'books.cart.digital' | translate }}</h3>
                        <div class="mb-3 mb-sm-1">
                            <p>
                                {{ 'cart.item.months_price' | translate }}: <strong>{{ pricingService.getCurrency() }}{{ pricingService.getAVPricing(book) | astreaCurrency }}</strong>
                                <small style="font-size: 13px;"> ({{ 'books.min_months' | translate }})</small>
                            </p>
                            <button (click)="handleDigitalBook()" class="btn btn-green mt-2" mat-button>
                                <img src="/assets/images/astrea-brand/av_isologo_white.svg" alt="Isologo Astrea Virtual">
                                {{ 'cart.add_digital' | translate }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <ng-template #getPublicFile>
                <div class="t-center w-100">
                    <a (click)="getFile('book', book.bookcode)" class="btn-book btn-doctrine" [attr.alt]="('see_doctrine' | translate) + ': ' + book.title" mat-button>
                        <div class="d-flex j-c-start a-i-center">
                            {{ (isPublicDoctrine ? ('see_article' | translate) : ('see_magazine' | translate)) }}
                            <astrea-loading *ngIf="loadingFile.loading && loadingFile.type == 'book'" class="ml-3" [diameter]="25" [stroke]="2"></astrea-loading>
                            <mat-icon *ngIf="!loadingFile.loading || loadingFile.type != 'book'">cloud_download</mat-icon>
                        </div>
                    </a>
                </div>
            </ng-template>

            <hr>

            <div class="my-3">
                <div *ngIf="book.summary" class="mb-2">
                    <mat-accordion>
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    {{ 'books.details.summary' | translate }}
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div [innerHtml]="book.summary.replaceAll('\n', '<br>')" class="astrea-comments">
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>
                <div *ngIf="book.comment" class="mb-2">
                    <mat-accordion>
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    {{ 'books.details.comments' | translate }}
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div [innerHtml]="book.comment" class="astrea-comments">
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>
            </div>

            <div *ngIf="book.vRelated && book.vRelated.length > 0" class="w-100 mt-2">
                <div class="mb-2">
                    <h3>{{ 'books.details.related' | translate }}</h3>
                </div>
                <table class="w-100">
                    <tr *ngFor="let b of book.vRelated " class="book-related" [ngClass]="{ 'disabled-link': b.useWeb ? false : true }">
                        <td class="p-2">
                            <a class="link-related-book d-flex j-c-start a-i-start" [routerLink]="['/book', b.bookcode]" title="{{ b.title }}">
                                {{ b.title }}
                            </a>
                            <small>
                                <a *ngFor="let a of getAuthorsRelatedBook(b)" class="link-related-author" [routerLink]="['/author', a.authorcode]" title="{{ 'books.details.author' | translate }}: {{ a.firstname }} {{ a.lastname }}">
                                    {{ a.lastname }}, {{ a.firstname }} -
                                </a>
                            </small>
                        </td>
                        <td>
                            <small class="related-price mr-3">
                                {{ pricingService.getCurrency() }}{{ pricingService.getWebPricing(b) | astreaCurrency }}
                            </small>
                        </td>
                    </tr>
                </table>
            </div>

        </div>
    </div>

    <ng-template #astreaLoading>
        <astrea-loading
            [text]="'books.loading' | translate"
        ></astrea-loading>
    </ng-template>

</div>
